import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { ThemeProvider } from "@mui/material/styles";

import Navbar from "./components/common/Navbar";
import Sidebar from "./components/common/sidebar/Sidebar";

import Login from "./pages/loginPage/Login";

import CssBaseline from "@mui/material/CssBaseline";
import { darkTheme, lightTheme } from "./theme";
import PageRoutes from "./routes/PageRoutes";

function App() {
  const { isAuthenticated, user } = useSelector((state) => state.login);
  const { mode } = useSelector((state) => state.mode);

  return (
    <ThemeProvider theme={mode === "light" ? lightTheme : darkTheme}>
      {isAuthenticated || user ? (
        <Box
          sx={{
            display: { sm: "flex", xs: "block" },
            flexDirection: "row",
            flexWrap: "nowrap",
          }}
        >
          <CssBaseline />
          <Navbar />
          <Sidebar />
          <PageRoutes />0
        </Box>
      ) : (
        <Login></Login>
      )}
    </ThemeProvider>
  );
}

export default App;
